import React from 'react'

const FilterSideModalLoader = ({ Loader, children, loaderProps, search, useLoader }) => {
  if (!useLoader) return children
  loaderProps = loaderProps || {}

  return (
    <Loader {...loaderProps} search={search}>
      {children}
    </Loader>
  )
}

export default FilterSideModalLoader
